import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ChatService } from '../service/chat.service';

@Injectable({
    providedIn: 'root'
})
export class ChatValidators
{
    public validateChatSpaceNameUnique(chatService: ChatService, control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                chatService.existsChatSpaceName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
